import React, { FC, useState, useEffect } from 'react'
import styles from 'styles/components/template.module.scss'
import { State } from 'index'
import { useSelector } from 'react-redux'
import { NavButton } from 'components/Button'
import { MessageList } from 'components/List'
import { Pagination } from 'components/Pagination'
import { Spacer } from 'components/Utility'
import { PER_PAGE } from 'constants/message'
import { fetchAdminMessages } from 'repos/message'
import { MessageType as BaseMessageType } from 'types/message'
import { FirebaseDocRefType } from 'firebase'

type MessageType = BaseMessageType & { ref: FirebaseDocRefType }

const PushListTemplate: FC = () => {
  const query = useSelector((state: State) => state.router.location.query)
  const currentPage = Number(query?.page ?? '1')

  const [adminMessages, setAdminMessages] = useState<MessageType[]>([])

  const totalAdminMessages = adminMessages.length ?? 0

  const startIndex = (currentPage - 1) * PER_PAGE
  const endIndex = Math.min(startIndex + PER_PAGE, totalAdminMessages)
  const AdminMessages = adminMessages.slice(startIndex, endIndex)

  useEffect(() => {
    ;(async () => {
      const adminMessages = await fetchAdminMessages()
      setAdminMessages(adminMessages)
    })()
  }, [])

  return (
    <div className={styles.standard}>
      <Spacer size={40} />
      <MessageList messages={AdminMessages} isAdminNotification={true} />
      <Pagination perPage={PER_PAGE} total={totalAdminMessages} />
      <Spacer size={24} />
      <NavButton label={'トップページに戻る'} iconPath={'/icon/grey/home.svg'} url={'/admin/shops'} />
      <Spacer size={40} />
    </div>
  )
}

export default PushListTemplate
